var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferralLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1969 2.80306C14.0561 1.66226 12.2065 1.66226 11.0656 2.80306L7.96717 5.90153C6.82639 7.04233 6.82639 8.89208 7.96717 10.0329C8.34749 10.4132 8.34749 11.0296 7.96717 11.4099C7.58686 11.7902 6.97032 11.7902 6.59019 11.4099C4.6888 9.50847 4.6888 6.42577 6.59019 4.52444L9.68861 1.42597C11.5899 -0.475323 14.6727 -0.475323 16.574 1.42597C18.4753 3.32738 18.4753 6.41008 16.574 8.31141C16.1938 8.69173 15.5771 8.69173 15.197 8.31141C14.8167 7.93126 14.8167 7.31455 15.197 6.93441C16.3378 5.79344 16.3378 3.94386 15.197 2.80306H15.1969ZM10.0326 6.59011C10.4129 6.20979 11.0294 6.20979 11.4097 6.59011C13.3111 8.49141 13.3111 11.5742 11.4097 13.4756L8.31129 16.574C6.4099 18.4753 3.32725 18.4753 1.42595 16.574C-0.475316 14.6726 -0.475316 11.5899 1.42595 9.68859C1.80626 9.30827 2.4228 9.30827 2.8031 9.68859C3.18325 10.0687 3.18325 10.6855 2.8031 11.0656C1.66232 12.2066 1.66232 14.0561 2.8031 15.1969C3.94388 16.3377 5.79344 16.3377 6.93422 15.1969L10.0327 12.0985C11.1736 10.9577 11.1736 9.10792 10.0327 7.96712C9.6525 7.5868 9.6525 6.97026 10.0327 6.59011H10.0326Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralLinkIcon);
export default __webpack_public_path__ + "static/media/referralLinkIcon.c6b71a7712660029524b64dac9cdf0f0.svg";
export { ForwardRef as ReactComponent };